export default __webpack_public_path__ + "static/media/ic_product_selected.e04c3e94.svg";